/**
 * @generated SignedSource<<cf4f3ed622433b879c03581e7dd18978>>
 * @relayHash a06ecd7e840d42accff21aa304ec49d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02646f85d0e05ec91d5f3ec1b2935309649c90007115051ff5d107a7d868a5b5

import type { ConcreteRequest } from 'relay-runtime';
export type useMeetingsQuery$variables = {
  cloudId: string;
  siteAri: string;
};
export type useMeetingsQuery$data = {
  readonly loom_meetingsSearch: {
    readonly recurring: ReadonlyArray<{
      readonly id: string;
      readonly inviteeAris: ReadonlyArray<string | null> | null;
      readonly invitees: ReadonlyArray<{
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null> | null;
      readonly recorder: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly recorderId: string | null;
      readonly startsAt: string | null;
      readonly title: string;
      readonly video: {
        readonly id: string;
        readonly isMeeting: boolean | null;
        readonly meetingAri: string | null;
        readonly url: string;
      } | null;
    } | null> | null;
    readonly single: ReadonlyArray<{
      readonly id: string;
      readonly inviteeAris: ReadonlyArray<string | null> | null;
      readonly invitees: ReadonlyArray<{
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null> | null;
      readonly recorder: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly recorderId: string | null;
      readonly startsAt: string | null;
      readonly title: string;
      readonly video: {
        readonly id: string;
        readonly isMeeting: boolean | null;
        readonly meetingAri: string | null;
        readonly url: string;
      } | null;
    } | null> | null;
  } | null;
  readonly loom_settings: {
    readonly meetingNotesAvailable: boolean | null;
    readonly meetingNotesEnabled: boolean | null;
  } | null;
};
export type useMeetingsQuery = {
  response: useMeetingsQuery$data;
  variables: useMeetingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "siteId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "LoomSettings",
  "kind": "LinkedField",
  "name": "loom_settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "meetingNotesAvailable"
    },
    {
      "kind": "ScalarField",
      "name": "meetingNotesEnabled"
    }
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "siteAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "title"
},
v6 = {
  "kind": "ScalarField",
  "name": "startsAt"
},
v7 = {
  "kind": "ScalarField",
  "name": "recorderId"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
},
v11 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "inviteeAris"
},
v13 = {
  "concreteType": "LoomVideo",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "isMeeting"
    },
    {
      "kind": "ScalarField",
      "name": "meetingAri"
    }
  ]
},
v14 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "LinkedField",
    "name": "recorder",
    "plural": false,
    "selections": (v11/*: any*/)
  },
  (v12/*: any*/),
  {
    "kind": "LinkedField",
    "name": "invitees",
    "plural": true,
    "selections": (v11/*: any*/)
  },
  (v13/*: any*/)
],
v15 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v4/*: any*/)
],
v16 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "LinkedField",
    "name": "recorder",
    "plural": false,
    "selections": (v15/*: any*/)
  },
  (v12/*: any*/),
  {
    "kind": "LinkedField",
    "name": "invitees",
    "plural": true,
    "selections": (v15/*: any*/)
  },
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useMeetingsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "LoomMeetings",
        "kind": "LinkedField",
        "name": "loom_meetingsSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "single",
            "plural": true,
            "selections": (v14/*: any*/)
          },
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "recurring",
            "plural": true,
            "selections": (v14/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useMeetingsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "LoomMeetings",
        "kind": "LinkedField",
        "name": "loom_meetingsSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "single",
            "plural": true,
            "selections": (v16/*: any*/)
          },
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "recurring",
            "plural": true,
            "selections": (v16/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a06ecd7e840d42accff21aa304ec49d1",
    "id": "02646f85d0e05ec91d5f3ec1b2935309649c90007115051ff5d107a7d868a5b5",
    "metadata": {},
    "name": "useMeetingsQuery",
    "operationKind": "query",
    "text": "query useMeetingsQuery($siteAri:ID!,$cloudId:ID!){loom_settings(siteId:$cloudId){meetingNotesAvailable,meetingNotesEnabled},loom_meetingsSearch(id:$siteAri){single{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri}},recurring{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri}}}}"
  }
};
})();

(node as any).hash = "203179ed49d6cc51268af7c38046ae88";

export default node;
